<template>
  <div>
    <div class="row mx-auto my-3">
      <div v-for="(item, index) in designObject">
        <div class="m-2 p-3 qrBtn" @click="chooseDesign(item.value)">
          <img :alt="item.value" :src="item.img" class="img-fluid" width="30" />
        </div>
      </div>
    </div>
    <div class="col-md-12">
      <v-file-input
        clearable
        dense
        label="آپلود لوگو"
        outlined
        prepend-icon=""
        prepend-inner-icon="mdi-camera"
        @change="getImg($event)"
      />
      <v-switch
        v-model="noBg"
        class="mt-0"
        label="لوگو بدون پس زمینه"
      ></v-switch>
      <v-slider
        v-model="logoSize"
        :max="100"
        :min="30"
        :step="1"
        label="سایزلوگو"
        thumb-label
      />
    </div>
  </div>
</template>

<script>
export default {
  name: "logoImg",
  data() {
    return {
      designObject: [
        { value: "none", img: "/media/img/none.svg" },
        {
          value: "images/watermarks/01-link-b.png",
          img: "/media/img/01-link-b.png",
        },
        {
          value: "images/watermarks/02-email-b.png",
          img: "/media/img/02-email-b.png",
        },
        {
          value: "images/watermarks/03-location-b.png",
          img: "/media/img/03-location-b.png",
        },
        {
          value: "images/watermarks/04-whatsapp.png",
          img: "/media/img/04-whatsapp.png",
        },
        {
          value: "images/watermarks/06-zoom-b.png",
          img: "/media/img/06-zoom-b.png",
        },
        {
          value: "images/watermarks/07-wifi-b.png",
          img: "/media/img/07-wifi-b.png",
        },
        {
          value: "images/watermarks/08-vcard-b.png",
          img: "/media/img/08-vcard-b.png",
        },
        {
          value: "images/watermarks/09-calendar-b.png",
          img: "/media/img/09-calendar-b.png",
        },
        {
          value: "images/watermarks/10-paypal.png",
          img: "/media/img/10-paypal.png",
        },
        {
          value: "images/watermarks/11-btc-b.png",
          img: "/media/img/11-btc-b.png",
        },
      ],
      logoInfo: {
        noBg: false,
        logoSize: 100,
        logoImg: "none",
      },
    };
  },
  methods: {
    chooseDesign(value) {
      this.logoInfo.logoImg = value;
    },
    getImg(e) {
      const reader = new FileReader();
      reader.readAsDataURL(e);
      reader.onload = () => {
        this.logoInfo.logoImg = reader.result;
      };
    },
  },
  watch: {
    logoInfo: {
      handler(val) {
        this.$emit("input", val);
      },
      deep: true,
    },
  },
};
</script>

<style scoped>
.qrBtn {
  border-radius: 15px !important;
  box-shadow: 8px 5px 10px #02105c8c;
  cursor: pointer;
}

.qrBtn:hover {
  border-radius: 0 !important;
  box-shadow: none !important;
}
</style>
